export default __webpack_public_path__ + "static/media/twitter.20e2ed58.svg";